<template>
  <div class="row">
      <div class="col-md-12 card">
          <div class="card-header">
            <div class="row">
                <div class="col-md-4">
                  <h3 class="title">{{ $t('harvests') }}</h3>
                </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
                <div class="col-md-6">
                  <el-select v-model="pagination.perPage" :placeholder="$t('per_page')">
                    <el-option
                      class="select-default"
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item">
                      </el-option>
                  </el-select>
                </div>
                <div class="col-sm-6">
                  <div class="pull-right">
                    <fg-input
                      class="input-sm"
                      :placeholder="$t('search')"
                      v-model="searchQuery"
                      addon-right-icon="nc-icon nc-zoom-split"
                    ></fg-input>
                  </div>
                </div>
             </div>
             <div class="row">
                  <el-table v-loading="loading" :element-loading-text="$t('loading_data')+'...'" class="table-striped" :data="paginated" border style="width: 100%">
                    <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth"
                      :prop="column.prop" :label="column.label" sortable="">
                    </el-table-column>
                  </el-table>
             </div>
          </div>
          <div class="card-footer">
            <paginate :pagination="pagination" :metadata="metaData" :allData="farmerHarvest"></paginate>
          </div>
      </div>
  </div>
</template>
<script>
import Resource from "@/util/Api/resource.js";
import PPagination from "src/components/UIComponents/Pagination.vue";
import Paginate from '@/components/UIComponents/Paginate.vue';
import Con from "@/util/helpers.js";


const harvestResource = new Resource("post/givenContentType/Harvest");
const FarmersHarvest = new Resource("post/givenContentType");
const CatResources = new Resource("category/childrenGivenParent");
const PostRefineResource = new Resource("post/trainsers/farmers/Harvest/0");

export default {
  components:{
     PPagination,
     Paginate
  },
  data() {
    return {
       country:'',
       ngo:'',
       searchQuery: '',

       NGO:[],
       Countries:[],
       tableData: [],
       allHarvests:[],

       tableColumns: [
          {prop: "cropName",label: this.$t("crops"),},
          {prop: "month",label: this.$t("month"),},
          {prop: "year",label: this.$t("year"),},
          {prop: "amount",label: this.$t("amount_ton"),},
          {prop: "people",label: this.$t("household")},
          {prop: "landSize",label: this.$t("land_size_hectare"), minWidth: "100"},
          {prop: "appliedFIFTraining",label: "FIF", minWidth: "50"},
        ],
        harvestDetails:{
            id:'',
            cropName:'',
            month:'',
            year:'',
            amount:'',
            people:'',
            landSize:'',
            appliedFIFTraining:'',
            postTemplateID: ''
        },
        pagination:{
            perPage: 10,
            perPageOptions: [10, 20, 30, 60, 500, 1000],
            currentPage:1,
            nextPage:'',
            prevPage:'',
            total:'',
            from:'',
            to:'',
            page:'',
        },
        metaData: {
           meta:'',
           links:''
        },

       loading: false,
    }
  },

  methods: {

     // Get all NGOs in a categories
    async getNGOs() {
      await CatResources.get(1).then(response => {
        this.NGO = response.data;
      }).catch(error => {
         this.showAlertMessage(error.response.data.message, "error");
      });
    },

    // Get all countries in a category
    async getCountry() {
      await CatResources.get(2).then(response => {
        this.Countries = response.data;
      }).catch(error => {
         this.showAlertMessage(error.response.data.message, "error");
      });
    },

    // Parse data
    parseAnswer(answer) {
        let data = "";
        if(answer.indexOf('"') > -1) {
           data = JSON.parse(answer);
        } else {
           data = answer;
        }
        return data;
    },

    // format data
    formatHarvestData(harvests) {
      this.allHarvests = [];
      harvests.forEach(harvest => {
        this.harvestDetails = [];
        this.harvestDetails.id = harvest.post.id;
        this.harvestDetails.postTemplateID = harvest.post.postTemplateID;

        harvest.postContent.forEach(element => {
                  if(element.Question.title.toLowerCase() === "select crop") {
                      if(element.Answer) {
                         this.harvestDetails.cropName = this.parseAnswer(element.Answer);
                      } else {
                         this.harvestDetails.cropName = "";
                      }
                  }

                  if(element.Question.title.toLowerCase() === "select month") {
                      if(element.Answer) {
                        this.harvestDetails.month = this.parseAnswer(element.Answer);
                      } else {
                        this.harvestDetails.month = "";
                      }
                  }

                  if(element.Question.title.toLowerCase() === "select year") {
                      if(element.Answer) {
                        this.harvestDetails.year = this.parseAnswer(element.Answer);
                      } else {
                        this.harvestDetails.year = "";
                      }
                  }

                  if(element.Question.title.toLowerCase() === "amount (tons)") {
                      if(element.Answer) {
                         this.harvestDetails.amount = this.parseAnswer(element.Answer);
                      } else {
                         this.harvestDetails.amount = "";
                      }
                  }

                  if(element.Question.title.toLowerCase() === "land size (hectares)") {
                      if(element.Answer) {
                         this.harvestDetails.landSize = this.parseAnswer(element.Answer);
                      } else {
                         this.harvestDetails.landSize  = "";
                      }
                  }

                  if(element.Question.title.toLowerCase() === "people in household") {
                    if(element.Answer) {
                         this.harvestDetails.people = this.parseAnswer(element.Answer);
                      } else {
                         this.harvestDetails.people = "";
                      }
                  }

                  if(element.Question.title.toLowerCase() === "applied fif training") {
                      if(element.Answer) {
                        this.harvestDetails.appliedFIFTraining = this.parseAnswer(element.Answer);
                      } else {
                        this.harvestDetails.appliedFIFTraining;
                      }
                  }
            });

            this.allHarvests.push(this.harvestDetails);
        });

        this.tableData = [...this.allHarvests, ...this.tableData];
    },

    // Getting the farmer harvest
    async farmerHarvest(page_url) {
        if(page_url) {
           page_url = Con.splitStringLinks(page_url);
        }
        this.loading = true;
        await PostRefineResource.list(page_url)
        .then(response => {
            this.formatHarvestData(response.data.data);
            this.metaData.meta = response.data.meta;
            this.metaData.links = response.data.links;
            this.loading = false;
        }).catch((error) => {
            this.loading = false;
            console.log("Error: ", error);
        })
     },

    capitalize(word) {
      if (typeof word !== 'string') return ''
      return word.charAt(0).toUpperCase() + word.slice(1)
    },

    paginate(array, length, pageNumber){
        this.pagination.from = array.length ? ((pageNumber - 1) * length) + 1 : ' ';
        this.pagination.to = pageNumber * length > array.length ? array.length : pageNumber * length;
        this.pagination.prevPage = pageNumber > 1 ? pageNumber : '';
        this.pagination.nextPage = array.length > this.pagination.to ? pageNumber + 1 : '';
        this.pagination.page = Math.ceil(array.length / length);
        this.pagination.total = array.length;
        return array.slice((pageNumber - 1) * length, pageNumber * length);
    },

  },

  created() {
    this.getNGOs();
    this.getCountry();
    this.farmerHarvest();
  },

  computed: {
    filterData() {
        let result = this.tableData;
        if (this.searchQuery) {
            result = result.filter((row) => {
                return Object.keys(row).some((key) => {
                    return (String(row[key]).toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1);
                })
            })
        }
        return result;
    },

    paginated() {
        return this.paginate(this.filterData, this.pagination.perPage, this.pagination.currentPage);
    },

  },
}
</script>
<style scoped>

</style>
